import React from 'react';
import PropTypes from 'prop-types';
import {PromoBoxComponent, PromoBoxInner} from './GeneralPromo.styles';
import Text from '../../../shared/JssOverridesText';
import RichText from '../../../shared/JssOverridesRichText';
import {withSitecoreContext, isEditorActive} from '@sitecore-jss/sitecore-jss-react';
import { trademarkFilterHelper } from '../../../../helpers/trademarkFilterHelper';

const GeneralPromoBox = ({style, title, copy,styleOverride, sitecoreContext}) => {

    const variant = styleOverride && styleOverride !== '' ? styleOverride : style;
    const bgClass = styleOverride ? `bg-${styleOverride}` : '';
    const variantClass = `variant-${variant}`;
    const { site, trademarkReplacements = [] } = sitecoreContext;
    return (
        <PromoBoxComponent variant={variant} className={`${bgClass} ${variantClass} ${site.name}`}>
            <PromoBoxInner>
                {title?.value && (
                    <h1
                        dangerouslySetInnerHTML={{
                            __html: trademarkFilterHelper(title.value, trademarkReplacements)
                        }}
                    />
                )}
                {copy?.value && (
                    <div
                        className="p"
                        dangerouslySetInnerHTML={{
                            __html: trademarkFilterHelper(copy.value, trademarkReplacements)
                        }}
                    />
                )}

            </PromoBoxInner>
        </PromoBoxComponent>
    );
};

GeneralPromoBox.propTypes = {
    title: PropTypes.object,
    copy: PropTypes.object,
    style: PropTypes.string,
  styleOverride: PropTypes.string,
};

export default withSitecoreContext()(GeneralPromoBox);